import React, { useState } from 'react';
import { Container, Main } from './styles';
import MenuHeader from './components/Menu';

export const Menu = ({
  company,
  params,
  setActivedTestimony,
  isDetail,
  retorno,
}) => {
  return (
    <Main primaryColor={company?.base_hexcolor}>
      <Container>
        <a href={`/${retorno?.currentLabel}`}>
          <img
            src={retorno?.logo_url || '/static/logo_recrutei_colorida.png'}
            alt="Recrutei Logo"
          />
        </a>
        <MenuHeader
          retorno={retorno}
          isDetail={isDetail}
          primaryColor={company?.base_hexcolor}
          params={params}
          setActivedTestimony={setActivedTestimony}
        />
      </Container>
    </Main>
  );
};
